module.exports = __webpack_public_path__ + "img/10.5dbc2943.png";